import { Component, OnInit } from '@angular/core';
import { ApiService, MiscConfig } from 'angular-lib';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '../../../services/loader.service';
import { Location } from '@angular/common';

@Component({
    selector: 'ez-gsm',
    template: require('./gsm.component.html'),
    styles: [require('./gsm.component.less')]
})
export class GsmComponent implements OnInit {
    public countryId: number;
    public number: string = '';
    public errorMsg: string;
    public typeStatus: string;
    public miscConfig: MiscConfig;
    public submitButtonDisabled: boolean = false;

    constructor(
        private apiService: ApiService,
        private translate: TranslateService,
        private loaderService: LoaderService,
        private location: Location
    ) {
    }

    public ngOnInit() {
        this.loaderService.show();
        this.apiService.miscConfig().subscribe((data) => {
            this.miscConfig = data;
            this.apiService.getAccountInformations().subscribe(
                (res) => {
                    this.countryId = res.countryId;
                    if (res.gsm !== null) {
                        this.number = res.gsm.gsm_national_number;
                    }
                    this.loaderService.hide();
                },
                error => {
                    this.loaderService.hide();
                }
            );
        });
    }

    public save() {
        if (this.number === '') {
            return false;
        }

        this.submitButtonDisabled = true;
        this.errorMsg = '';
        this.loaderService.show();

        this.apiService.saveGsm(this.number, this.countryId).subscribe(
            (data) => {
                if (data.success === true) {
                    this.submitButtonDisabled = false;
                    this.translate.get('common.save-successfull').subscribe((str) => {
                        this.errorMsg = str;
                    });
                    this.typeStatus = 'success';
                }
            }, e => {
                this.submitButtonDisabled = false;
                this.typeStatus = 'error';
                this.errorMsg = e.message;
            },
            () => {
                this.loaderService.hide();
            }
        );
    }

    public back() {
        this.location.back();
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/account/gsm/gsm.component.ts